import { create } from 'zustand';
import { nanoid } from 'nanoid';
import { getSite } from '../config/siteConfig';

const LS_KEY = 'mdv-strings';

function storageKey() {
  const name = String(getSite()?.projectName || '').trim();
  return name ? `${LS_KEY}:${name}` : LS_KEY;
}

function loadStrings() {
  try {
    const raw = localStorage.getItem(storageKey()) || localStorage.getItem(LS_KEY);
    const list = raw ? JSON.parse(raw) : [];
    return Array.isArray(list) ? list : [];
  } catch {
    return [];
  }
}

function persist(strings) {
  try {
    localStorage.setItem(storageKey(), JSON.stringify(strings));
  } catch {
    // quota / private mode
  }
}

export const useStringLayerStore = create((set, get) => ({
  strings: loadStrings(),
  digitizing: false,
  draft: [],
  visible: true,
  setVisible: (visible) => set({ visible: Boolean(visible) }),
  addStrings: (incoming) => {
    const rows = (incoming || [])
      .filter((s) => Array.isArray(s.points) && s.points.length >= 2)
      .map((s) => ({
        id: s.id || nanoid(8),
        name: String(s.name || 'string').trim() || 'string',
        closed: Boolean(s.closed),
        points: s.points.map((p) => ({
          east: Number(p.east),
          north: Number(p.north),
          rl: Number(p.rl),
        })),
      }));
    if (!rows.length) return 0;
    const strings = [...rows, ...get().strings].slice(0, 80);
    persist(strings);
    set({ strings });
    return rows.length;
  },
  removeString: (id) => {
    const strings = get().strings.filter((s) => s.id !== id);
    persist(strings);
    set({ strings });
  },
  clearStrings: () => {
    persist([]);
    set({ strings: [], draft: [], digitizing: false });
  },
  startDigitize: () => set({ digitizing: true, draft: [] }),
  addDraftPoint: (mine) => {
    if (!mine) return;
    set((state) => ({
      digitizing: true,
      draft: [...state.draft, { east: mine.east, north: mine.north, rl: mine.rl }],
    }));
  },
  finishDigitize: (name) => {
    const draft = get().draft || [];
    if (draft.length < 2) {
      set({ digitizing: false, draft: [] });
      return false;
    }
    get().addStrings([{ name: name || `string ${get().strings.length + 1}`, points: draft }]);
    set({ digitizing: false, draft: [] });
    return true;
  },
  cancelDigitize: () => set({ digitizing: false, draft: [] }),
}));
